
function init(el) {
	if (!el.form) return
	el.addEventListener('change', () => {
		el.form.submit()
	})
}

export default input => {
	if (input instanceof HTMLElement) 
		return init(input)
	if (typeof input === 'string') 
		return [...document.querySelectorAll(input)].map(el => init(el))
}